<template>
  <div class="list-swiper2">
    <div class="list-item swiper-box">
      <swiper
        ref="mySwiper"
        class="swiper"
        :options="swiperOptions"
      >
        <swiper-slide
          v-for="(item, index) in list"
          :key="index"
          class="swiper-slide"
        >
          <div class="card" @click="onSwiperChange(item)">
            <div class="info">
              <div class="left">
                <h3 class="title">{{ item.title }}</h3>
                <ul class="tags">
                  <li
                    v-for="(item1, index1) in tagArray(item.keywrod)"
                    :key="index1"
                    class="van-ellipsis"
                  >
                    {{ item1 }}
                  </li>
                </ul>
              </div>
              <div class="right">
                查看详情
                <img :src="require('@/assets/jiantou.svg')" alt="" />
              </div>
            </div>

            <img class="img" :src="item.images | image_filter" alt="" />
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  name: "SWIPER1",
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  filters: {
    image_filter(val) {
      const images = val.split(",");
      return images[0];
    },
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      active: 0,
      swiperOptions: {
        direction: "vertical",
        slidesPerView: "auto",
        // loop: true,
      },
    };
  },
  computed: {
    list() {
      return this.data;
    },
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  methods: {
    tagArray(value) {
      return value.split(",");
    },

    onSidebarChange(index) {
      this.swiper.slideTo(index);
      this.swiper.update();
    },

    onSwiperChange(item) {
      this.$router.push({
        path: "/cate/info",
        query: {
          id: item.id,
        },
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.list-swiper2 {
  height: 100%;
  position: relative;

  .list-item {
    height: 100%;
  }
}

.swiper-box {
  flex: 1;
  overflow: hidden;
  box-sizing: border-box;
  height: 100%;
  // padding-left: 90px;
  max-width: 800px !important;
  margin: auto;
  position: relative;

  .list-sidebar {
    position: absolute;
    left: 0;
    top: 10px;
  }

  @media screen and (max-width: 500px) {
    .swiper-slide {
      height: 130px;
      .card {
        .info {
          font-size: 12px;
        }
      }
    }
  }

  @media screen and (min-width: 500px) {
    .swiper-slide {
      height: 230px;
    }
  }

  .swiper {
    height: 100%;
    padding: 0 16px;
    .swiper-slide {
      padding: 5px 0;
      .card {
        height: 100%;
        overflow: hidden;
        overflow: hidden;
        border-radius: 8px;
        box-sizing: border-box;
        box-shadow: 0 5px 10px 0 rgb(50 50 50 / 15%);
        position: relative;

        .img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          position: absolute;
          top: 0;
          left: 0;
          z-index: -10;
        }

        .info {
          position: absolute;
          left: 0;
          bottom: 0;
          right: 0;
          color: #fff;
          padding: 10px;
          box-sizing: border-box;

          display: flex;
          align-items: end;
          justify-content: space-between;

          .left {
            flex: 1;
            .title {
              margin-top: 20px;
            }
            .tags {
              li {
                width: 100px;
                display: inline-block;
                font-size: 10px;
                border-width: 1px;
                border-style: solid;
                margin-top: 5px;
                padding: 2px 4px;
                border-radius: 4px;
                &:not(:last-child) {
                  margin-right: 5px;
                }
              }
            }
          }

          .right {
            width: 120px;
            height: 30px;
            color: #ccc;
            clear: both;
            border-width: 1px;
            display: flex;
            font-size: 14px;
            justify-content: flex-end;
            align-items: center;
            img {
              width: 30px;
              margin-left: 5px;
            }
          }
        }
      }
    }
  }
}
</style>
